var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransactionHistoryIconInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 21.8906C21.75 22.7191 21.0784 23.3906 20.25 23.3906H3.75C2.92157 23.3906 2.25 22.7191 2.25 21.8906V2.39062C2.25 1.5622 2.92157 0.890625 3.75 0.890625H14.379C14.7765 0.89071 15.1578 1.04861 15.439 1.32963L21.311 7.20162C21.592 7.48282 21.7499 7.86408 21.75 8.26162V21.8906Z",
    stroke: "#8D9D91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 8.39062H15.75C14.9216 8.39062 14.25 7.71905 14.25 6.89062V0.890625",
    stroke: "#8D9D91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.2 11.7347C6.63952 12.312 7.33302 12.6386 8.058 12.6097C9.197 12.6097 10.121 11.9167 10.121 11.0627C10.121 10.2087 9.2 9.51675 8.062 9.51675C6.924 9.51675 6 8.82375 6 7.96875C6 7.11375 6.924 6.42175 8.062 6.42175C8.78709 6.39236 9.48081 6.71906 9.92 7.29675",
    stroke: "#8D9D91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0625 12.6094V13.6404",
    stroke: "#8D9D91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0625 5.39062V6.42163",
    stroke: "#8D9D91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.1406H18",
    stroke: "#8D9D91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 19.6406H18",
    stroke: "#8D9D91",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionHistoryIconInactive);
export default __webpack_public_path__ + "static/media/transaction-history-icon-Inactive.f7c1e36005b64c59ca4f1b16ce41688b.svg";
export { ForwardRef as ReactComponent };